import React from 'react'
import './Testimonial.css'
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import { FaQuoteLeft } from 'react-icons/fa6';

const Testimonial = () => {
    const settings = {
        dots: true,
        arrows: false,
        infinite: false,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 2,
              }
            },
            {
              breakpoint: 1000,
              settings: {
                slidesToShow: 2,
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
              }
            }
          ]
      };

      const Testidate = [
        {
            Desc: "Working with 360 Bytes has been really smooth for us. They always understood what we wanted.",
            Name: "City Center Doha",
            Company: "Company"
        },
        {
            Desc: "We wanted a team who could get things done without us worrying about the details, and they have done that. They’re reliable, and their results have always matched what we wanted.",
            Name: "Monoprix",
            Company: "Company"
        },
        {
            Desc: "Our experience with 360 Bytes has been great. The team is supportive and flexible and that makes a big difference for us.",
            Name: "Naseem Al Rabeeh",
            Company: "Company"
        },
        {
            Desc: "This company has been a solid partner for us. They understand our vision and help us bring it to life in the best way possible. The team is quite friendly and committed to delivering good work.",
            Name: "Qatar Cricket Association",
            Company: "Company"
        }
      ]

  return (
    <section className='hmtest-sec'>
        <div className='container'>
            <Slider {...settings}>
                {
                    Testidate.map ((Testimonial, index)=>(
                        <div key={index}>
                            <div className='hmtest'>
                                <FaQuoteLeft/>
                                <p>{Testimonial.Desc}</p>
                                <h4>{Testimonial.Name} <br/> <span>{Testimonial.Company}</span></h4>
                            </div>
                        </div>    
                    ))
                }
            </Slider>
        </div>
    </section>
  )
}

export default Testimonial
